import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import {Avatar, Box, Card, CardContent, CardHeader, Divider, Link} from '@mui/material';
import { SearchDocument } from '../../../types/search/searchDocument';


interface Props {
    newsPosts: SearchDocument[];
}


const NewsList = (props:Props): JSX.Element => {

    const theme = useTheme();

    const [newsPosts, setNewsPostList] = useState<SearchDocument[]>([]);
    const [toggleViewMore, setToggleViewMore] = useState(false);
    
    useEffect(() => {
      setNewsPostList(props.newsPosts.slice(0,3));
      setToggleViewMore(props.newsPosts.length > 3? true: false);
        }, [props.newsPosts]);
    
    const handleViewMore = () => {
        setToggleViewMore(!toggleViewMore);
        setNewsPostList(props.newsPosts);
    }

    return (
     <Box>
        <Typography
            variant="h6"
            align={'left'}
            sx={{
            fontWeight: 700,
            }}
            color={'secondary'}
            paddingTop={2}
            gutterBottom
        >
        News
        </Typography>
        <Divider textAlign="right">
            <Typography component={'i'} variant='body2' color="primary">{props.newsPosts.length} total results</Typography>
        </Divider>
        <Grid container marginTop={3}>
        {newsPosts?.map((item, i) => (
           <Grid size={{xs:12, md:10}} key={i} marginBottom={2}>
              <Card component={"div"} id={`news-${item.id}`} >
                  <CardHeader
                    avatar={
                      <Typography
                        variant={'subtitle2'}
                        fontWeight={550}
                          sx={{
                            bgcolor: alpha(theme.palette.success.light, 0.1),
                            color: theme.palette.success.dark,
                            paddingX: 1.5,
                            paddingY: 0.5,
                            display: 'inline',
                          }}
                      >
                        {item.date}
                      </Typography>
                    }
                            title={ 
                                <Typography variant="subtitle1" fontWeight={550} >
                                    {item.title}
                                </Typography>
                          }
                  />
                  <Divider/>
                  <CardContent>
                    <Typography component={"p"} variant="body2" role="region" aria-label="News content">
                      <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                    </Typography>
                  </CardContent>
              </Card>
          </Grid>
        ))}
          {
            props.newsPosts.length > 3 && 
            <Grid size={10} display="flex" justifyContent="flex-end" marginTop={1}>
                <Link underline='hover' onClick={handleViewMore} fontSize={"small"}><i>View More Results</i></Link>
            </Grid>
          }
        </Grid>
  </Box>
  );
};

export default NewsList;